import { render, staticRenderFns } from "./DashboardCustomer.vue?vue&type=template&id=1746f76d&"
import script from "./DashboardCustomer.vue?vue&type=script&lang=ts&"
export * from "./DashboardCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCustomer.vue?vue&type=style&index=0&id=1746f76d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports